import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
// utils
//
//
import { DEFAULT_LANG } from './config-lang';
import cnLocales from './langs/cn';
import enLocales from './langs/en';
import esLocales from './langs/es';
import ptBrLocales from './langs/pt-br';

// ----------------------------------------------------------------------

const SUPPORTED_LANGS = ['pt', 'en', 'es', 'cn'];

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translations: enLocales },
      es: { translations: esLocales },
      pt: { translations: ptBrLocales },
      cn: { translations: cnLocales },
    },
    fallbackLng: DEFAULT_LANG,
    supportedLngs: SUPPORTED_LANGS,
    nonExplicitSupportedLngs: true,
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'i18nextLng',
      caches: ['localStorage'],
    }
  });

export default i18n;
